module.exports = __webpack_public_path__ + "static/media/photo-l.0d8489eb.jpg";